<template>
  <a-drawer
    :title="title"
    :maskClosable="true"
    :width="800"
    placement="right"
    :closable="true"
    @close="cnacel"
    :visible="visible"
    style="overflow: auto; padding-bottom: 53px"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="姓名">
          <a-input
            placeholder="请输入姓名"
            :max-length="16"
            v-decorator="['name', validatorRules.name]"
          />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="岗位职责分类"
        >
          <a-select
            v-decorator="[
              'responsibilityType',
              validatorRules.responsibilityType
            ]"
          >
            <a-select-option :value="0">投资交易相关人员</a-select-option>
            <a-select-option :value="1">中后台核对专岗人员</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="岗位分类"
        >
          <j-dict-select-tag
            type="list"
            v-decorator="['positionType', validatorRules.positionType]"
            :trigger-change="true"
            dictCode="POSITION_TYPE"
            placeholder="请选择"
          />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="部门">
          <span v-if="hasChoose" @click="visibleDepart = true">{{ dept }}</span>
          <span style="color: #1890ff" @click="visibleDepart = true" v-else
            >点击选择部门</span
          >
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="是否离职"
        >
          <a-select
            placeholder="请选择"
            v-decorator="['isLeave', validatorRules.isLeave]"
          >
            <a-select-option :value="0">否</a-select-option>
            <a-select-option :value="1">是</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="办公电话"
        >
          <a-input
            placeholder="请输入办公电话"
            :max-length="16"
            v-decorator="['tel', validatorRules.tel]"
          />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="离职日期"
        >
          <j-date
            placeholder="请选择离职日期"
            v-decorator="['leaveDate']"
            style="width: 100%"
          />
        </a-form-item>
      </a-form>
    </a-spin>
    <div class="drawer-bootom-button">
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="cnacel"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: 0.8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleOk" type="primary">提交</a-button>
    </div>
    <!-- 部门选择 -->
    <a-drawer
      title="部门选择"
      width="500"
      placement="right"
      :closable="false"
      :visible="visibleDepart"
      @close="visibleDepart = false"
    >
      <a-input-search
        @search="onSearch"
        style="width: 100%; margin-top: 10px"
        placeholder="请输入部门名称"
      />

      <a-tree
        @select="onCheck"
        :treeData="departTree"
        :expandedKeys="iExpandedKeys"
        :autoExpandParent="autoExpandParent"
        @expand="onExpand"
      />
      <div class="drawer-bootom-button">
        <a-popconfirm
          title="确定放弃编辑？"
          @confirm="handleCancel"
          okText="确定"
          cancelText="取消"
        >
          <a-button style="margin-right: 0.8rem">取消</a-button>
        </a-popconfirm>
        <!-- <a-button @click="handleOk" type="primary">提交</a-button> -->
      </div>
    </a-drawer>
  </a-drawer>
</template>

<script>
import { httpAction } from '@/api/manage';
import pick from 'lodash.pick';
import JDate from '@/components/jeecg/JDate';
import JDictSelectTag from '@/components/dict/JDictSelectTag';
import { queryDepartTreeList, searchByKeywords } from '@/api/api';
export default {
  data() {
    return {
      dept: '',
      hasChoose: false,
      visibleDepart: false,
      autoExpandParent: true,
      departTree: [],
      selectedKeys: [],
      checkedKeys: [],
      iExpandedKeys: [],

      title: '新增',
      visible: false,
      // model:'year',
      model: {},
      branch: {}, //部门
      selectOption: {}, //岗位分类
      typeText: '',
      value: '',
      yearPick: null,
      yearPickShow: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules: {
        dept: { rules: [{ required: true, message: '请输入执业岗位!' }] },
        name: { rules: [{ required: true, message: '请输入姓名!' }] },
        isLeave: { rules: [{ required: true, message: '请选择是否离职!' }] },
        positionType: {
          rules: [{ required: true, message: '请选择岗位分类!' }]
        },
        responsibilityType: {
          rules: [{ required: true, message: '请选择职责类型!' }]
        },
        tel: { rules: [{ required: true, message: '请输入办公电话!' }] },
        duty: { rules: [{ required: true, message: '请选择职务!' }] }
      },
      url: {
        add: process.env.VUE_APP_CMS_CONTENT + '/cont/person/save',
        edit: process.env.VUE_APP_CMS_CONTENT + '/cont/person/save'
      }
    };
  },
  components: {
    JDate,
    JDictSelectTag
  },
  created() {
    // this.queryDepartmentOption()
    // this.selectDepartmentOption()
    this.loadTree();
  },
  methods: {
    onExpand(expandedKeys) {
      console.log('onExpand', expandedKeys);
      this.iExpandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    loadTree() {
      var that = this;
      that.treeData = [];
      that.departTree = [];
      queryDepartTreeList().then(res => {
        if (res.success) {
          //部门全选后，再添加部门，选中数量增多
          this.allTreeKeys = [];
          for (let i = 0; i < res.result.length; i++) {
            let temp = res.result[i];
            that.treeData.push(temp);
            that.departTree.push(temp);
            that.setThisExpandedKeys(temp);
            that.getAllKeys(temp);
            // console.log(temp.id)
          }
          this.loading = false;
        }
      });
    },
    setThisExpandedKeys(node) {
      if (node.children && node.children.length > 0) {
        this.iExpandedKeys.push(node.key);
        for (let a = 0; a < node.children.length; a++) {
          this.setThisExpandedKeys(node.children[a]);
        }
      }
    },
    getAllKeys(node) {
      // console.log('node',node);
      this.allTreeKeys.push(node.key);
      if (node.children && node.children.length > 0) {
        for (let a = 0; a < node.children.length; a++) {
          this.getAllKeys(node.children[a]);
        }
      }
    },
    onCheck(checkedKeys, info) {
      console.log('onCheck', checkedKeys, info);
      this.hiding = false;
      let record = info.node.dataRef;
      this.dept = info.node.dataRef.departName;
      // this.currSelected = Object.assign({}, record);
      // this.model = this.currSelected;
      // this.selectedKeys = [record.key]
      // this.model.parentId = record.parentId;
      // this.setValuesToForm(record)
      // this.$refs.departAuth.show(record.id);
      this.checkedKeys = [];
      checkedKeys.map(item => {
        this.checkedKeys.push(item);
      });
      this.hasChoose = true;
      this.visibleDepart = false;
    },
    onSearch(value) {
      let that = this;
      if (value) {
        searchByKeywords({ keyWord: value }).then(res => {
          if (res.success) {
            that.departTree = [];
            for (let i = 0; i < res.result.length; i++) {
              let temp = res.result[i];
              that.departTree.push(temp);
            }
          } else {
            that.$message.warning(res.message);
          }
        });
      } else {
        that.loadTree();
      }
    },
    add() {
      this.edit({});
    },
    edit(record) {
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      if (record && record.dept) {
        this.hasChoose = true;
        this.dept = record.dept;
      } else {
        this.hasChoose = false;
        this.dept = '';
      }
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(
            this.model,
            'isLeave',
            'leaveDate',
            'name',
            'positionType',
            'responsibilityType',
            'tel',
            'dept'
          )
        );
      });
    },
    //获取部门
    // async queryDepartmentOption() {
    //   const res = await queryDepartment()
    //   this.branch = res.result ? res.result : {}
    //   console.log(this.branch, '>>>.')
    // },
    //获取岗位分类数据
    // async selectDepartmentOption() {
    //   const res = await selectDepartment()
    //   this.selectOption = res.result ? res.result : {}
    // },
    close() {
      this.$emit('close');
      this.visibleDepart = false;
    },
    onChange() {},
    handleOk() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let httpurl = '';
          let method = '';
          if (!this.model.id) {
            httpurl += this.url.add;
            method = 'POST';
          } else {
            httpurl += this.url.edit;
            method = 'POST';
          }
          let formData = Object.assign(this.model, values);
          formData.personType = 1;
          // formData.responsibilityType =
          //   formData.responsibilityType == '中后台核对专岗人员' ? 1 : 0;
          formData.dept = this.dept;
          console.log(formData);
          //时间格式化
          httpAction(httpurl, formData, method).then(res => {
            console.log(res);
            if (res.success) {
              that.$message.success(res.message);
              that.$emit('ok', that.model);
              that.confirmLoading = false;
              that.close();
              that.visible = false;
            } else {
              that.$message.warning(res.message);
              that.confirmLoading = false;
            }
          });
        }
      });
    },
    handleCancel() {
      this.close();
    },
    cnacel() {
      this.visible = false;
    },
    handleOpenChange(status) {
      console.log(status, '============');
      this.yearPickShow = status;
    },
    // 得到年份选择器的值
    handlePanelChange(value) {
      console.log(value);
      this.yearPick = value;
      console.log(this.yearPick);
      this.yearPickShow = false;
    }
  }
};
</script>

<style>
.ant-col-sm-5 {
  width: 30%;
}
.drawer-bootom-button {
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
</style>
